module.exports = __webpack_public_path__ + "static/media/EAI-09.1107885a.jpg";